import * as actionTypes from './actionTypes';
import { ITransactionType } from '@evercall/domain/vo/TransactionType';
import { IDialInCountry } from '@evercall/domain/vo/DialInCountry';
import { IAction } from '@framework/state/createAction';
import { IPlatform } from '@evercall/domain/vo/Platform';

export interface IReducerState {
  isInitialized: boolean,
  isFetchingLists: boolean,
  isSubmitting: boolean,
  isSubmitSucceeded: boolean,
  transactionTypeList: ITransactionType[],
  countryList: IDialInCountry[],
  platformList: IPlatform[],
}

export const initialState: IReducerState = {
  isInitialized: false,
  isFetchingLists: false,
  isSubmitting: false,
  isSubmitSucceeded: false,
  transactionTypeList: [],
  countryList: [],
  platformList: [],
};

export default (state: IReducerState, action: IAction): IReducerState => {
  switch (action.type) {
    case actionTypes.GET_CALL_FORM_LISTS:
      return {
        ...state,
        isFetchingLists: true,
      };
    case actionTypes.GET_CALL_FORM_LISTS_SUCCESS:
      const [transactionTypeList, countryList, platformList] = action.payload;
      return {
        ...state,
        isFetchingLists: false,
        transactionTypeList,
        countryList,
        platformList,
      };
    case actionTypes.GET_CALL_FORM_LISTS_ERROR:
      return {
        ...state,
        isFetchingLists: false,
      };
    case actionTypes.SET_IS_SUBMITTING:
      return {
        ...state,
        isSubmitting: action.payload,
      };
    case actionTypes.SET_IS_INITIALIZED:
      return {
        ...state,
        isInitialized: action.payload,
      };
    case actionTypes.SET_IS_SUBMIT_SUCCEEDED:
      return {
        ...state,
        isSubmitSucceeded: action.payload,
      };
    case actionTypes.RESET_CALL_SETTINGS_FORM:
      return initialState;
    default:
      return state;
  }
};
